module.exports = require('./lib/linkify-string').default;



//////////////////
// WEBPACK FOOTER
// ../~/linkifyjs/string.js
// module id = 401
// module chunks = 9